import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Tools", -1)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "Bulk update tool", -1)
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, " The tool allows a bulk update for a given list of RP's IDs ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MainSection = _resolveComponent("MainSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, null, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_MainSection, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_router_link, {
                  class: "btn btn-primary",
                  to: { name: 'BulkUpdater' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Go to tool")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}